import useProjectEntriesCall, { toTimestampLike } from './useProjectEntriesCall'

/**
 * @typedef {object} ReportEntry
 * @property {string} docid - Document-id
 * @property {{toDate: () => Date} | null} Timestamp - Zelfde vorm als een Firestore-Timestamp
 */

/** @returns {ReportEntry} */
const toDoc = (/** @type {{id: string, t: number|null}} */ entry) => ({
    docid: entry.id,
    Timestamp: toTimestampLike(entry.t),
})

/**
 * Id en tijdstip van de rapportages van één project, voor de voortgangspagina van de
 * koepel, via de Cloud Function `getProjectReportEntries`. Las tot 2026-11-04 rechtstreeks
 * uit LiveReports, wat alleen werkte omdat iedereen die collectie mocht lezen.
 *
 * @param {string} compagnyId - Het project; '' = nog onbekend
 * @returns {{docs: Array<ReportEntry> | '', error: {code?: string, message?: string} | null, loading: boolean}}
 */
const useProjectReportEntries = (compagnyId) => useProjectEntriesCall(
    'getProjectReportEntries', compagnyId, toDoc, 'useProjectReportEntries'
)

export default useProjectReportEntries
